//@ts-check

import React, { useMemo } from 'react';
import { Row } from 'antd';
import { Controller, useFormContext } from 'react-form';
import { Label } from 'reactstrap';

import TextReply from '../Content/Complete/AssigmentComplete/TextReply';
import RecordVideo from '../Content/Complete/AssigmentComplete/RecordVideo';
import RecordAudio from '../Content/Complete/AssigmentComplete/RecordAudio/RecordAudio';

import FileUpload from 'components/AntdFormInputs/file-upload';

import useI18n from 'hooks/use-i18n';
import { useTest } from 'hooks/units';
import UploadFile from '../Content/Complete/AssigmentComplete/UploadFile';
import { UNIT_DATA_TYPE } from 'constants/constants';
import { parseHtml } from 'helpers';

const AssignmentType = () => {
  const form = useFormContext();
  const i18n = useI18n();
  const test = useTest();
  const assignmentType = form.watch('assignmentType');
  const previewContent = form.watch('previewContent');
  const config = test?.question?.config;

  const fileConfig = useMemo(
    () => ({
      maxVideoSize: Number(config?.video?.maxVideoSize),
      noOfVideoFile: Number(config.video?.noOfVideo),
      maxAudioSize: Number(config?.audio?.maxAudioSize),
      noOfAudioFile: Number(config?.audio?.noOfAudioFile),
      maxFileSize: Number(config?.file?.maxFileSize),
      noOfFiles: Number(config?.file?.noOfFiles),
    }),
    [test?._id],
  );

  const uploadProps = useMemo(
    () => ({
      upload: {
        fileList: test?.question?.assignmentFile?.map((item) => ({
          url: `${item.path}`,
          name: item.title,
          ...item,
        })),
        showUploadList: { showRemoveIcon: false, removeIcon: false },
      },
    }),
    [test?.question?._id],
  );

  const handleUpdateUrl = (files) => {
    const data = (Array.isArray(files) ? files : [files]).map((item) => ({
      name: item?.originalname,
      url: `${item?.path}`,
      _id: item?._id,
    }));

    form.setValue('previewContent', data);
  };

  const renderAssignmentComponent = (Component, type) => (
    <Controller
      name="data.0.value"
      control={form.control}
      render={({ field }) => (
        <Controller
          name="assignmentType"
          control={form.control}
          rules={{ required: i18n.t('message.errorRequired') }}
          render={(typeField) => (
            <Component
              isDisabled={false}
              type={typeField.field.value}
              setType={typeField.field.onChange}
              setIntervalFunc={() => {}}
              maxSize={1}
              allowMultipleUploads={true}
              limit={3}
              onSubmitCompleteUnit={(data, files) => {
                typeField.field.onChange('');
                form.setValue('data.0.type', type);
                if (type === 'TEXT') {
                  field.onChange(data?.content);
                } else {
                  field.onChange(data?._id);
                }
                handleUpdateUrl(files);
              }}
            />
          )}
        />
      )}
    />
  );

  return (
    <>
      <FileUpload
        {...uploadProps}
        listFileOnly
        pureCss={`span {padding: 0px !important}`}
      >
        <div className="w-100 d-flex">
          <Label htmlFor="attach-file" className="form-inputlabel-title">
            Attachment File:
          </Label>
        </div>
      </FileUpload>

      <p className="text-center mb-0 mt-1">
        {assignmentType === 'FILE' &&
          `Maximum ${
            fileConfig?.noOfFiles || '--'
          } file is allowed. The file has a maximum size of ${
            fileConfig?.maxFileSize ? fileConfig?.maxFileSize : '5'
          }MB.`}

        {assignmentType &&
          (assignmentType === 'AUDIO' || assignmentType === 'VIDEO') &&
          `Maximum ${
            assignmentType === 'AUDIO'
              ? fileConfig.noOfAudioFile
              : fileConfig.noOfVideoFile
          } file is allowed. The file has a maximum size of ${
            assignmentType === 'AUDIO'
              ? fileConfig.maxAudioSize
              : fileConfig.maxVideoSize
          }  MB.`}
      </p>

      {[UNIT_DATA_TYPE.AUDIO, UNIT_DATA_TYPE.VIDEO, 'FILE'].includes(
        assignmentType,
      ) && previewContent?.length ? (
        <FileUpload
          upload={{
            fileList: previewContent,
            onRemove: (data) => {
              const newContent = previewContent?.filter(
                (item) => item?.uid !== data?.uid,
              );
              const ids = newContent?.map((item) => item?._id);
              form.setValue('previewContent', newContent);
              form.setValue('data.0.value', ids);
            },
          }}
          listFileOnly
          pureCss={`span { padding: 16px 0 0 0 !important }`}
        >
          <div className="w-100 d-flex">
            <Label htmlFor="attach-file" className="form-inputlabel-title">
              Your Upload Files:
            </Label>
          </div>
        </FileUpload>
      ) : assignmentType === 'TEXT' ? (
        parseHtml(previewContent)
      ) : (
        <Row
          justify="center"
          className={`px-1 py-2 ${assignmentType ? 'd-block' : ''}`}
        >
          {renderAssignmentComponent(TextReply, 'TEXT')}
          {renderAssignmentComponent(UploadFile, 'FILE')}
          {renderAssignmentComponent(RecordVideo, 'VIDEO')}
          {renderAssignmentComponent(RecordAudio, 'AUDIO')}
        </Row>
      )}
    </>
  );
};

export default AssignmentType;
